"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouter = require("react-router");

var _epics = _interopRequireDefault(require("./epics"));

var _scopeChecks = require("settings-ui-lib/utils/scopeChecks");

var _Route = require("./constants/Route");

var _AccessControl = require("./constants/AccessControl");

var _tracking = require("settings-ui-app/utils/tracking");

var _reducers = _interopRequireDefault(require("./reducers"));

var _AsyncMultiCurrencyTab = _interopRequireDefault(require("./containers/AsyncMultiCurrencyTab"));

var _AsyncGeneralInfoTab = _interopRequireDefault(require("./containers/AsyncGeneralInfoTab"));

var _AccountDefaultsContainer = _interopRequireDefault(require("./containers/AccountDefaultsContainer"));

var _AsyncBrandingTab = _interopRequireDefault(require("./containers/AsyncBrandingTab"));

var ALLOWED_SCOPES = [_AccessControl.SCOPES.READ, _AccessControl.SCOPES.WRITE];
var _default = {
  reducer: _reducers.default,
  routes: _react.default.createElement(_reactRouter.Route, {
    path: _Route.ROUTE,
    component: _AccountDefaultsContainer.default
  }, _react.default.createElement(_reactRouter.IndexRedirect, {
    to: "general"
  }), _react.default.createElement(_reactRouter.Route, {
    path: "general",
    component: _AsyncGeneralInfoTab.default,
    onEnter: (0, _tracking.trackScreenUsingSideNav)('general')
  }), _react.default.createElement(_reactRouter.Route, {
    path: "branding(/:tabName)",
    component: _AsyncBrandingTab.default,
    onEnter: (0, _tracking.trackScreenUsingSideNav)('branding')
  }), _react.default.createElement(_reactRouter.Route, {
    path: "multicurrency",
    component: _AsyncMultiCurrencyTab.default,
    onEnter: (0, _tracking.trackScreenUsingSideNav)('multicurrency')
  })),
  route: _Route.ROUTE,
  rootEpic: _epics.default,
  shouldModuleRender: (0, _scopeChecks.matchesSomeScopes)(ALLOWED_SCOPES)
};
exports.default = _default;
module.exports = exports.default;